import { useTranslation } from 'react-i18next'
import { Button } from '@velasca/ui/button'
import { SansText } from '@velasca/ui/sans-text'
import { $settings } from '@velasca/utils/globals'
import { trackEvent } from '@velasca/utils/track-event'
import { Background, GoToCheckoutButtonWrapper } from './Footer.styles'

interface FooterProps {
  cartTotalValue: number
}

export const Footer = ({ cartTotalValue }: FooterProps): JSX.Element => {
  const { t } = useTranslation('cartDrawer')

  const handleGoToCheckoutButtonClick = () => {
    trackEvent({
      teads: {
        eventName: 'InitiateCheckout',
        data: {
          name: 'Cart',
          price: cartTotalValue,
          currency: $settings.currency,
        },
      },
    })
  }

  return (
    <Background>
      <GoToCheckoutButtonWrapper>
        <Button
          fullWidth
          name="checkout"
          type="submit"
          text={t('checkout')}
          onClick={handleGoToCheckoutButtonClick}
        />
      </GoToCheckoutButtonWrapper>
      <SansText
        uppercase
        underline
        margin="0.8rem 0 0 0"
        as="a"
        color="light"
        href="/cart"
        fontWeight="500"
      >
        {t('cart_drawer_footer_cart_link_text')}
      </SansText>
      <SansText size="sm" fontStyle="italic">
        {t('cart_drawer_footer_message')}
      </SansText>
    </Background>
  )
}
